<div>
  <div class="live-chat-toast" *ngIf="liveChatToast">
    <span class="material-icons">forum</span>
    {{ liveChatToast }}
    <a routerLink="/telephony/messages" (click)="liveChatNotifications.clear()">Open</a>
  </div>

  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav #snav
      [mode]="(isHandset$ | async) ? 'over' : 'side'"
      [opened]="(isHandset$ | async) === false"
      class="sidenav">

      <!-- Brand -->
      <div class="sidebar-brand">
        <div class="sidebar-brand-logo">
          <span class="material-icons">account_balance</span>
        </div>
        <div class="sidebar-brand-info">
          <div class="sidebar-brand-name">GRMIS</div>
          <div class="sidebar-brand-sub">Admin Portal</div>
        </div>
      </div>

      <!-- Navigation -->
      <mat-nav-list>
        <ng-container *ngFor="let m of menu | sortbyPipe; let i = index; trackBy: trackById">
          <div *ngIf="m?.subMenu?.length; else singleMenuItem"
               class="sidebar-menu-item-container"
               [class.has-submenu]="m.subMenu.length > 0"
               [class.active]="isParentMenuActive(m.subMenu)">
            <a mat-list-item class="sidebar-menu-item" (click)="toggleSubMenu(i)">
              <span class="sidebar-item-icon-wrap">
                <mat-icon *ngIf="m.title!='Dashboard' && m.title!='Groups'; else imageIcon">{{m?.icon}}</mat-icon>
                <ng-template #imageIcon>
                  <img class="image-icon" [src]="'assets/img/'+m.title+'.svg'"/>
                </ng-template>
              </span>
              <span class="sidebar-menu-title">{{m?.title}}</span>
              <mat-icon class="sidebar-chevron">{{ isSubMenuOpen(i) ? 'expand_less' : 'expand_more' }}</mat-icon>
            </a>
            <div *ngIf="isSubMenuOpen(i)" class="sub-menu-container" [ngClass]="{'sub-menu-open': isSubMenuOpen(i)}">
              <a mat-list-item *ngFor="let sm of m?.subMenu | sortbyPipe; trackBy: trackById"
                 [routerLink]="sm?.route" routerLinkActive="active" class="sub-menu-item">
                <span class="sidebar-menu-title">{{sm?.title}}</span>
                <span *ngIf="sm?.route === '/telephony/messages' && liveChatUnread > 0" class="live-chat-menu-badge">
                  {{ liveChatUnread > 99 ? '99+' : liveChatUnread }}
                </span>
              </a>
            </div>
          </div>
          <ng-template #singleMenuItem>
            <a mat-list-item [routerLink]="m?.route" routerLinkActive="active"
               [routerLinkActiveOptions]="{ exact: true }" class="sidebar-menu-item">
              <span class="sidebar-item-icon-wrap">
                <mat-icon>{{m?.icon}}</mat-icon>
              </span>
              <span class="sidebar-menu-title">{{m?.title}}</span>
            </a>
          </ng-template>
        </ng-container>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <app-header (toggleSidenav)="snav.toggle()"></app-header>
      <section id="main-body" class="main-height">
        <router-outlet></router-outlet>
      </section>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<app-chatbot *ngIf="chatbotEnabled"></app-chatbot>
